module.exports = require("mdast-util-to-string");


//////////////////
// WEBPACK FOOTER
// external "mdast-util-to-string"
// module id = 14
// module chunks = 0 1 2 3 4 5 6 7 8 9 12 13 14